class TalukModel{
    talukId:number;
    name?: string;
   
    
}
export default TalukModel;